import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { PeselInput } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

import { StyledPeselField } from './PeselField.styled';

type PeselFormBeanPart = {
   pesel?: Pesel | null;
};
type PeselFieldProps = Pick<FormContextValues<PeselFormBeanPart>, 'register'>;

export const PeselField = (props: PeselFieldProps): JSX.Element => {
   return (
      <StyledPeselField>
         <PeselInput
            controller={props.register('pesel', {
               required: true,
            })}
            label={patientTranslationKeys.personalIdentifier}
            testId={'pesel'}
         />
      </StyledPeselField>
   );
};
